export default "__VITE_PUBLIC_ASSET__cefa968d__"